import isFirefox from '@/utilities/isFirefox';
import isSafari from '@/utilities/isSafari';

(function () {
  if (isFirefox() || isSafari()) {
    document?.documentElement?.style?.setProperty?.('--paragraph-white-space', 'pre-line');
  }
})();
